module.exports = __webpack_public_path__ + "static/Football Club Fan Application-2dcb21f3d11daf121f8d2de5b2c5b2eb.svg";